import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon_collect_choosed",
  "use": "icon-icon_collect_choosed-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-icon_collect_choosed\"><clipPath id=\"icon-icon_collect_choosed_a\"><path d=\"m0 0h16v16h-16z\" /></clipPath><clipPath id=\"icon-icon_collect_choosed_b\"><path d=\"m0 0h16v16h-16z\" /></clipPath><g clip-path=\"url(#icon-icon_collect_choosed_a)\"><g clip-path=\"url(#icon-icon_collect_choosed_b)\"><path d=\"m8 16c4.4 0 8-3.6 8-8s-3.6-8-8-8-8 3.6-8 8 3.6 8 8 8z\" fill=\"#00B279\" /><path d=\"m5.9 11.5-2.8-2.8c-.4-.4-.4-1 0-1.4s1-.4 1.4 0l2.1 2.1 4.3-4.3c.4-.4 1-.4 1.4 0s.4 1 0 1.4l-5 5c-.3.4-1 .4-1.4 0z\" fill=\"#fff\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/icon_collect_choosed.svg
// module id = qsij
// module chunks = 87